import { render, staticRenderFns } from "./NewRdcSelect.vue?vue&type=template&id=16c04027&"
import script from "./NewRdcSelect.vue?vue&type=script&lang=js&"
export * from "./NewRdcSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports